import { z as t } from "zod";
import { ColumnDataType as N, ComputeJobAutoFetching as E, ComputeJobPurpose as A, ComputeJobStatus as P, DataConnectorJobType as w, DataImportExportStatus as H, DataRoomKind as T, DataSourceType as U, DataTargetType as F, DatasetUsage as k, DraftEditorRole as x, FeatureVisibilityState as z, MatchingColumnFormat as q, OrganizationState as L, PermutiveServiceProvider as M, PublishedDataRoomSource as J, SalesforceProductType as O, ScopeType as B, ScriptingLanguage as K, SortOrder as W, SubmittedDataRoomRequestProcessingStatus as V, SyntheticMaskType as G, TableColumnFormatType as Q, TableColumnHashingAlgorithm as X, UserRole as Y, WorkerTypeShortName as Z } from "./types.js";
const _ = (o) => o != null, sn = t.any().refine((o) => _(o)), s = t.nativeEnum(N), mn = t.nativeEnum(E), $ = t.nativeEnum(A), un = t.nativeEnum(P), ln = t.nativeEnum(w), tt = t.nativeEnum(H), cn = t.nativeEnum(T), nt = t.nativeEnum(U), f = t.nativeEnum(F), it = t.nativeEnum(k), et = t.nativeEnum(x), n = t.nativeEnum(z), a = t.nativeEnum(q), rt = t.nativeEnum(L), at = t.nativeEnum(M), hn = t.nativeEnum(J), ot = t.nativeEnum(O), gn = t.nativeEnum(B), I = t.nativeEnum(K), p = t.nativeEnum(W), dn = t.nativeEnum(V), D = t.nativeEnum(G), l = t.nativeEnum(Q), r = t.nativeEnum(X), m = t.nativeEnum(Y), pn = t.nativeEnum(Z);
function bn() {
  return t.object({
    commitId: t.string().trim(),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    id: t.string().trim().min(1)
  });
}
function c() {
  return t.object({
    accessKey: t.string().trim().min(1),
    secretKey: t.string().trim().min(1)
  });
}
function j() {
  return t.object({
    blobName: t.string().trim().min(1),
    sasToken: t.string().trim().min(1),
    storageAccount: t.string().trim().min(1),
    storageContainer: t.string().trim().min(1)
  });
}
function u() {
  return t.object({
    equalTo: t.boolean().nullish(),
    notEqualTo: t.boolean().nullish()
  });
}
function Sn() {
  return t.object({
    activityPeriodOverlapsWithInterval: h().nullish(),
    isDataRoomActive: t.boolean().nullish(),
    isOwnedByOrganization: t.boolean().nullish()
  });
}
function fn() {
  return t.object({
    advertiserDomains: t.array(t.string().trim().min(1)).nullish(),
    allowExclusionTargeting: t.boolean().nullish(),
    allowInsights: t.boolean().nullish(),
    allowLookalike: t.boolean().nullish(),
    allowMeasurements: t.boolean().nullish(),
    allowRetargeting: t.boolean().nullish(),
    allowRuleBasedAudiences: t.boolean().nullish(),
    matchAnyDomain: t.boolean().nullish(),
    matchingIdFormat: a,
    matchingIdHashingAlgorithm: r.nullish(),
    name: t.string().trim().min(1),
    publisherDisplayConfigurationId: t.string().trim().min(1),
    publisherParticipants: t.array(t.string().trim().min(1)).nullish()
  });
}
function In() {
  return t.object({
    description: t.string().trim().nullish(),
    name: t.string().trim().min(1)
  });
}
function Dn() {
  return t.object({
    computeNodeId: v(),
    dataRoomHash: t.string().trim().nullish(),
    driverAttestationHash: t.string().trim(),
    enclaveComputeJobHandleBase64: t.string().trim().min(1),
    enclaveComputeJobId: t.string().trim().min(1),
    purpose: $.nullish()
  });
}
function jn() {
  return t.object({
    config: t.string().trim().nullish(),
    payload: st()
  });
}
function st() {
  return t.object({
    exportDataset: It().nullish(),
    exportDcrJobResult: Dt().nullish(),
    importDataset: jt().nullish()
  });
}
function yn() {
  return t.object({
    dataLab: t.string().trim()
  });
}
function Cn() {
  return t.object({
    matchingIdFormat: a,
    matchingIdHashingAlgorithm: r.nullish(),
    name: t.string().trim().min(1),
    numEmbeddings: t.number(),
    requireDemographicsDataset: t.boolean(),
    requireEmbeddingsDataset: t.boolean(),
    requireSegmentsDataset: t.boolean()
  });
}
function vn() {
  return t.object({
    collaborationRequestUsers: t.array(t.string().trim().min(1)),
    description: t.string().trim().nullish(),
    logo: t.string().trim().nullish(),
    marketIds: t.array(t.string().trim().min(1)).nullish(),
    name: t.string().trim().min(1),
    organizationId: t.string().trim().nullish()
  });
}
function Rn() {
  return t.object({
    advertiserDomains: t.array(t.string().trim().min(1)).nullish(),
    allowExclusionTargeting: t.boolean().nullish(),
    allowInsights: t.boolean().nullish(),
    allowLookalike: t.boolean().nullish(),
    allowRetargeting: t.boolean().nullish(),
    allowRulesBasedAudiences: t.boolean().nullish(),
    dataPartnerDisplayConfigurationId: t.string().trim().min(1),
    matchAnyDomain: t.boolean().nullish(),
    matchingIdFormat: a,
    matchingIdHashingAlgorithm: r.nullish(),
    name: t.string().trim().min(1),
    participants: t.array(t.string().trim().min(1)).nullish()
  });
}
function Nn() {
  return t.object({
    draftNode: t.lazy(() => y()),
    publishedDataRoomId: t.string().trim().min(1)
  });
}
function En() {
  return t.object({
    draftNode: t.lazy(() => y()),
    publishedDataRoomId: t.string().trim().min(1)
  });
}
function An() {
  return t.object({
    signature: t.string().trim(),
    submittedDataRoomRequestId: t.string().trim().min(1)
  });
}
function Pn() {
  return t.object({
    chunkHashes: t.array(t.string().trim()),
    description: t.string().trim().nullish(),
    isAccessory: t.boolean().nullish(),
    manifest: t.string().trim(),
    manifestHash: t.string().trim(),
    name: t.string().trim().min(1),
    scopeId: t.string().trim().min(1),
    size: t.number().nullish(),
    statistics: t.string().trim().nullish(),
    uploadId: t.string().trim().min(1),
    usage: it.nullish()
  });
}
function wn() {
  return t.object({
    manifestHash: t.string().trim().nullish()
  });
}
function Hn() {
  return t.object({
    dataRoomHash: t.string().trim().min(1),
    driverAttestationHash: t.string().trim().nullish()
  });
}
function Tn() {
  return t.object({
    email: t.string().trim().min(1),
    logo: t.string().trim().nullish(),
    password: t.string().trim().min(1),
    userRole: m
  });
}
function mt() {
  return t.object({
    draftNodeId: t.string().trim().min(1)
  });
}
function Un() {
  return t.object({
    draftNodeId: t.string().trim().min(1),
    draftParticipantId: t.string().trim().min(1)
  });
}
function y() {
  return t.object({
    match: t.lazy(() => lt().nullish()),
    post: t.lazy(() => ht().nullish()),
    preview: t.lazy(() => gt().nullish()),
    s3Sink: t.lazy(() => dt().nullish()),
    scripting: t.lazy(() => pt().nullish()),
    sql: t.lazy(() => bt().nullish()),
    sqlite: t.lazy(() => St().nullish()),
    synthetic: t.lazy(() => ft().nullish())
  });
}
function ut() {
  return t.object({
    draftNodeId: t.string().trim().min(1)
  });
}
function Fn() {
  return t.object({
    draftNodeId: t.string().trim().min(1),
    draftParticipantId: t.string().trim().min(1)
  });
}
function kn() {
  return t.object({
    description: t.string().trim().min(1),
    draftParticipants: t.array(t.string().email().trim()).nullish(),
    enableDevelopment: t.boolean(),
    enableInteractivity: t.boolean(),
    requirePassword: t.boolean().nullish(),
    showOrganizationLogo: t.boolean().nullish(),
    title: t.string().trim().min(1)
  });
}
function xn() {
  return t.object({
    draftDataRoomId: t.string().trim().min(1),
    isArchived: t.boolean(),
    isFavorite: t.boolean()
  });
}
function zn() {
  return t.object({
    draftDataRoomId: t.string().trim().min(1),
    role: et,
    userId: t.string().trim().min(1)
  });
}
function lt() {
  return t.object({
    config: t.string().trim().nullish(),
    draftDataRoomId: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    name: t.string().trim().min(1),
    output: t.string().trim().nullish()
  });
}
function qn() {
  return t.object({
    permissions: t.array(t.lazy(() => ct())).nullish(),
    userEmail: t.string().trim().min(1)
  });
}
function ct() {
  return t.object({
    analyst: t.lazy(() => mt().nullish()),
    dataOwner: t.lazy(() => ut().nullish())
  });
}
function ht() {
  return t.object({
    draftDataRoomId: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    name: t.string().trim().min(1)
  });
}
function gt() {
  return t.object({
    draftDataRoomId: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    name: t.string().trim().min(1),
    quotaBytes: t.number().nullish()
  });
}
function Ln() {
  return t.object({
    draftDataRoomId: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    isRequired: t.boolean().nullish(),
    name: t.string().trim().min(1)
  });
}
function dt() {
  return t.object({
    draftDataRoomId: t.string().trim().nullish(),
    endpoint: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    name: t.string().trim().min(1),
    region: t.string().trim().nullish()
  });
}
function Mn() {
  return t.object({
    content: t.string().trim().nullish(),
    draftScriptingNodeId: t.string().trim().min(1),
    isMainScript: t.boolean(),
    name: t.string().trim().nullish()
  });
}
function pt() {
  return t.object({
    draftDataRoomId: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    initialScript: t.lazy(() => Wt().nullish()),
    name: t.string().trim().min(1),
    output: t.string().trim().nullish(),
    scriptingLanguage: I
  });
}
function bt() {
  return t.object({
    draftDataRoomId: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    name: t.string().trim().min(1),
    privacyFilterIsEnabled: t.boolean().nullish(),
    privacyFilterMinimumRow: t.number().nullish(),
    statement: t.string().trim().nullish()
  });
}
function St() {
  return t.object({
    draftDataRoomId: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    name: t.string().trim().min(1),
    privacyFilterIsEnabled: t.boolean().nullish(),
    privacyFilterMinimumRow: t.number().nullish(),
    statement: t.string().trim().nullish()
  });
}
function ft() {
  return t.object({
    accuracy: t.number().nullish(),
    dependencyUpdatedAt: t.string().datetime().nullish(),
    draftDataRoomId: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    includeReportWithStats: t.boolean().nullish(),
    name: t.string().trim().min(1)
  });
}
function Jn() {
  return t.object({
    dataType: s,
    draftTableLeafNodeId: t.string().trim().min(1),
    formatType: l.nullish(),
    hashWith: r.nullish(),
    isNullable: t.boolean(),
    name: t.string().trim().min(1)
  });
}
function On() {
  return t.object({
    allowEmpty: t.boolean().nullish(),
    columns: t.array(t.lazy(() => Vt())).nullish(),
    draftDataRoomId: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    isRequired: t.boolean().nullish(),
    maxRows: t.number().nullish(),
    minRows: t.number().nullish(),
    name: t.string().trim().min(1),
    uniqueness: t.lazy(() => R().nullish())
  });
}
function Bn() {
  return t.object({
    report: t.lazy(() => vt())
  });
}
function It() {
  return t.object({
    manifestHash: t.string().trim().min(1),
    targetType: f
  });
}
function Dt() {
  return t.object({
    commitId: t.string().trim().min(1),
    manifestHash: t.string().trim().min(1),
    name: t.string().trim().min(1),
    targetType: f
  });
}
function Kn() {
  return t.object({
    email: t.string().trim().min(1)
  });
}
function jt() {
  return t.object({
    datasetDescription: t.string().trim().nullish(),
    datasetName: t.string().trim().min(1),
    name: t.string().trim().min(1),
    sourceType: nt
  });
}
function Wn() {
  return t.object({
    email: t.string().trim().min(1),
    organizationId: t.string().trim().min(1),
    userRole: m
  });
}
function Vn() {
  return t.object({
    cacheKey: t.string().trim().min(1),
    computeNodeName: t.string().trim().min(1),
    jobIdHex: t.string().trim().min(1),
    jobType: t.string().trim().min(1),
    publishedDataRoomId: t.string().trim().min(1)
  });
}
function Gn() {
  return t.object({
    authPolicy: t.string().trim().nullish(),
    description: t.string().trim().nullish(),
    logo: t.string().trim().nullish(),
    mediaScope: t.string().trim().nullish(),
    microsoftDspMember: t.string().trim().nullish(),
    name: t.string().trim().min(1),
    state: rt,
    workerTypes: t.array(t.string().trim().min(1)).nullish()
  });
}
function Qn() {
  return t.object({
    isArchived: t.boolean(),
    isFavorite: t.boolean(),
    publishedDataRoomId: t.string().trim().min(1)
  });
}
function Xn() {
  return t.object({
    collaborationRequestUsers: t.array(t.string().trim().min(1)),
    description: t.string().trim().nullish(),
    logo: t.string().trim().nullish(),
    marketIds: t.array(t.string().trim().min(1)).nullish(),
    organizationId: t.string().trim().nullish(),
    publisherName: t.string().trim().min(1)
  });
}
function Yn() {
  return t.object({
    enclaveAttestationHash: t.string().trim().min(1)
  });
}
function Zn() {
  return t.object({
    dataType: s,
    index: t.number(),
    maskType: D.nullish(),
    name: t.string().trim().nullish(),
    shouldMaskColumn: t.boolean().nullish()
  });
}
function yt() {
  return t.object({
    delimiter: t.string().trim().nullish(),
    hasHeader: t.boolean().nullish(),
    keepOnlyColumns: t.array(t.number())
  });
}
function _n() {
  return t.object({
    createdAfter: t.string().datetime().nullish(),
    createdBefore: t.string().datetime().nullish(),
    inStates: t.array(tt).nullish()
  });
}
function $n() {
  return t.object({
    activityPeriodOverlapsWithInterval: h().nullish(),
    isArchived: u().nullish(),
    isFavorite: u().nullish(),
    isOwnedByUser: u().nullish(),
    ownerId: S().nullish(),
    ownerOrganizationId: S().nullish()
  });
}
function ti() {
  return t.object({
    createdAt: p.nullish(),
    updatedAt: p.nullish()
  });
}
function h() {
  return t.object({
    from: t.string().datetime(),
    until: t.string().datetime()
  });
}
function ni() {
  return t.object({
    datasetId: t.string().trim().min(1),
    manifestHash: t.string().trim(),
    publications: t.string().trim()
  });
}
function ii() {
  return t.object({
    cacheKey: t.string().trim().min(1),
    computeNodeName: t.string().trim().min(1),
    jobType: t.string().trim().min(1),
    publishedDataRoomId: t.string().trim().min(1),
    userId: t.string().trim().nullish()
  });
}
function Ct() {
  return t.object({
    content: t.string().trim().min(1),
    name: t.string().trim().min(1)
  });
}
function vt() {
  return t.object({
    details: t.string().trim().min(1),
    errorContext: t.array(t.lazy(() => Ct())),
    origin: t.string().trim().min(1)
  });
}
function Rt() {
  return t.object({
    aws: g(),
    segmentOwners: t.array(t.string().trim().min(1))
  });
}
function Nt() {
  return t.object({
    credentials: j()
  });
}
function Et() {
  return t.object({
    advertiserId: t.string().trim().min(1),
    credentials: t.string().trim().min(1),
    description: t.string().trim().min(1),
    displayName: t.string().trim().min(1),
    membershipDurationDays: t.string().trim().min(1),
    userConsentGiven: t.boolean()
  });
}
function C() {
  return t.object({
    bucketName: t.string().trim().min(1),
    credentials: t.string().trim().min(1),
    objectName: t.string().trim().min(1)
  });
}
function At() {
  return t.object({
    bucket: t.string().trim().min(1),
    credentials: t.string().trim().min(1),
    identifierKind: t.string().trim().min(1),
    inputHasHeader: t.boolean(),
    listId: t.string().trim().min(1),
    objectName: t.string().trim().min(1)
  });
}
function Pt() {
  return t.object({
    accessToken: t.string().trim().min(1),
    adAccountId: t.string().trim().min(1),
    audienceName: t.string().trim().min(1)
  });
}
function wt() {
  return t.object({
    memberId: t.string().trim().min(1),
    segmentCode: t.string().trim().min(1),
    segmentShortName: t.string().trim().min(1)
  });
}
function Ht() {
  return t.object({
    aws: g().nullish(),
    credentials: Qt(),
    gcs: C().nullish(),
    importId: t.string().trim().min(1),
    inputHasHeader: t.boolean(),
    segmentCode: t.string().trim().min(1),
    segmentName: t.string().trim().min(1)
  });
}
function g() {
  return t.object({
    credentials: c(),
    targetConfig: Zt()
  });
}
function Tt() {
  return t.object({
    seatId: t.string().trim().min(1),
    userDefinedAudienceName: t.string().trim().min(1)
  });
}
function ei() {
  return t.object({
    adformDsp: Rt().nullish(),
    azure: Nt().nullish(),
    dv360: Et().nullish(),
    gcs: C().nullish(),
    googleAdManager: At().nullish(),
    manifestHash: t.string().trim().min(1),
    meta: Pt().nullish(),
    microsoftDsp: wt().nullish(),
    permutive: Ht().nullish(),
    s3: g().nullish(),
    splicky: Tt().nullish()
  });
}
function ri() {
  return t.object({
    export: t.string().trim()
  });
}
function Ut() {
  return t.object({
    credentials: j()
  });
}
function Ft() {
  return t.object({
    computeNodeId: t.string().trim().min(1),
    dataRoomId: t.string().trim().min(1),
    driverAttestationHash: t.string().trim(),
    importFileWithName: t.string().trim().nullish(),
    isHighLevelNode: t.boolean().nullish(),
    parameters: t.array(Gt()).nullish(),
    renameFileTo: t.string().trim().nullish(),
    shouldImportAllFiles: t.boolean().nullish(),
    shouldImportAsRaw: t.boolean().nullish()
  });
}
function kt() {
  return t.object({
    bucketName: t.string().trim().min(1),
    credentials: t.string().trim().min(1),
    objectName: t.string().trim().min(1)
  });
}
function xt() {
  return t.object({
    configuration: Jt(),
    credentials: Ot(),
    datasets: Bt(),
    serviceProvider: at
  });
}
function zt() {
  return t.object({
    credentials: c(),
    sourceConfig: Yt()
  });
}
function qt() {
  return t.object({
    apiName: t.string().trim().min(1),
    credentials: _t(),
    domainUrl: t.string().trim().min(1),
    productType: ot.nullish()
  });
}
function Lt() {
  return t.object({
    credentials: en(),
    sourceConfig: rn()
  });
}
function ai() {
  return t.object({
    azure: Ut().nullish(),
    compute: Ft().nullish(),
    datasetName: t.string().trim().min(1),
    gcs: kt().nullish(),
    permutive: xt().nullish(),
    s3: zt().nullish(),
    salesforce: qt().nullish(),
    snowflake: Lt().nullish()
  });
}
function Mt() {
  return t.object({
    bucket: t.string().trim().min(1),
    region: t.string().trim().min(1)
  });
}
function Jt() {
  return t.object({
    aws: Mt().nullish(),
    gcs: Kt().nullish()
  });
}
function Ot() {
  return t.object({
    aws: c().nullish(),
    gcs: Xt().nullish()
  });
}
function Bt() {
  return t.object({
    demographicsDatasetName: t.string().trim().nullish(),
    matchingDatasetName: t.string().trim().min(1),
    segmentsDatasetName: t.string().trim().min(1)
  });
}
function Kt() {
  return t.object({
    bucketName: t.string().trim().min(1)
  });
}
function Wt() {
  return t.object({
    content: t.string().trim().nullish(),
    isMainScript: t.boolean(),
    name: t.string().trim().nullish()
  });
}
function Vt() {
  return t.object({
    dataType: s,
    formatType: l.nullish(),
    hashWith: r.nullish(),
    isNullable: t.boolean(),
    name: t.string().trim().min(1)
  });
}
function oi() {
  return t.object({
    dataRoomDescription: t.string().trim().min(1),
    publishedDataRoomDriverAttestationHash: t.string().trim().min(1),
    publishedDataRoomEnclaveId: t.string().trim().min(1)
  });
}
function si() {
  return t.object({
    cacheKey: t.string().trim().min(1),
    jobType: t.string().trim().min(1),
    publishedDataRoomId: t.string().trim().min(1)
  });
}
function mi() {
  return t.object({
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    id: t.string().trim().min(1)
  });
}
function v() {
  return t.object({
    draft: t.string().trim().nullish(),
    published: t.string().trim().nullish()
  });
}
function ui() {
  return t.object({
    activityPeriodOverlapsWithInterval: h().nullish(),
    participantOrganizationIdEquals: t.string().trim().nullish()
  });
}
function Gt() {
  return t.object({
    computeNodeName: t.string().trim().min(1),
    content: t.string().trim().min(1)
  });
}
function Qt() {
  return t.object({
    apiKey: t.string().trim().min(1)
  });
}
function Xt() {
  return t.object({
    credentials: t.string().trim().min(1)
  });
}
function li() {
  return t.object({
    computeNodeId: t.string().trim().min(1),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    enclaveJobId: t.string().trim(),
    jobId: t.string().trim().min(1)
  });
}
function ci() {
  return t.object({
    computeNodeIds: t.array(t.string().trim().min(1)).nullish(),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    enclaveComputeJobId: t.string().trim().min(1),
    jobId: t.string().trim().min(1)
  });
}
function hi() {
  return t.object({
    dataLabId: t.string().trim().min(1),
    dataRoomId: t.string().trim().min(1)
  });
}
function gi() {
  return t.object({
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    encryptionKey: t.string().trim(),
    leafNodeId: t.string().trim().min(1),
    manifestHash: t.string().trim()
  });
}
function di() {
  return t.object({
    id: t.string().trim().min(1),
    publishedDataRoomDriverAttestationHash: t.string().trim(),
    publishedDataRoomEnclaveId: t.string().trim().min(1)
  });
}
function pi() {
  return t.object({
    id: t.string().trim().min(1),
    keepTestData: t.boolean(),
    password: t.string().trim().nullish(),
    validate: t.boolean()
  });
}
function bi() {
  return t.object({
    newEnclaveCommitId: t.string().trim(),
    newEnclaveConfigurationPin: t.string().trim(),
    newSigners: t.array(t.string().email().trim()),
    submittedDataRoomRequestId: t.string().trim().min(1)
  });
}
function Si() {
  return t.object({
    commitId: t.string().trim(),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    id: t.string().trim().min(1)
  });
}
function fi() {
  return t.object({
    id: t.string().trim().min(1),
    nodeId: t.string().trim().min(1),
    testDatasets: t.array(e()).nullish()
  });
}
function Ii() {
  return t.object({
    computeNodeId: t.string().trim().min(1),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    testDatasets: t.array(e()).nullish()
  });
}
function Di() {
  return t.object({
    computeNodeId: t.string().trim().min(1),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    jobId: t.string().trim(),
    resultFileName: t.string().trim().min(1)
  });
}
function ji() {
  return t.object({
    computeNodeId: t.string().trim().min(1),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    jobId: t.string().trim()
  });
}
function yi() {
  return t.object({
    autoFetching: t.boolean().nullish(),
    computeNodeId: t.string().trim().min(1),
    dataRoomId: t.string().trim().min(1),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    testDatasets: t.array(e()).nullish()
  });
}
function Ci() {
  return t.object({
    autoFetching: t.boolean().nullish(),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    id: t.string().trim().min(1),
    testDatasets: t.array(e()).nullish()
  });
}
function vi() {
  return t.object({
    autoFetching: t.boolean().nullish(),
    commitId: t.string().trim(),
    computeNodeId: t.string().trim().min(1),
    dataRoomId: t.string().trim().min(1),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    testDatasets: t.array(e()).nullish()
  });
}
function Yt() {
  return t.object({
    bucket: t.string().trim().min(1),
    objectKey: t.string().trim().min(1),
    region: t.string().trim().min(1)
  });
}
function Zt() {
  return t.object({
    bucket: t.string().trim().min(1),
    objectKey: t.string().trim().min(1),
    region: t.string().trim().min(1)
  });
}
function _t() {
  return t.object({
    clientId: t.string().trim().min(1),
    clientSecret: t.string().trim().min(1)
  });
}
function Ri() {
  return t.object({
    id: t.string().trim().min(1),
    manifestHash: t.string().trim().nullish()
  });
}
function Ni() {
  return t.object({
    id: t.string().trim().min(1),
    jobsDriverAttestationHash: t.string().trim().min(1),
    statisticsComputeJobId: t.string().trim().min(1),
    validationComputeJobId: t.string().trim().min(1)
  });
}
function Ei() {
  return t.object({
    id: t.string().trim().min(1),
    statistics: t.string().trim().nullish()
  });
}
function Ai() {
  return t.object({
    computeJobId: t.string().trim().min(1),
    computeJobNode: t.string().trim().min(1),
    dataRoomId: t.string().trim().min(1),
    driverAttestationHash: t.string().trim().min(1),
    id: t.string().trim().min(1)
  });
}
function b() {
  return t.object({
    value: t.number().nullish()
  });
}
function i() {
  return t.object({
    value: t.string().trim().nullish()
  });
}
function $t() {
  return t.object({
    value: l.nullish()
  });
}
function d() {
  return t.object({
    value: r.nullish()
  });
}
function Pi() {
  return t.object({
    datasetId: t.string().trim().min(1),
    leafNodeId: v()
  });
}
function tn() {
  return t.object({
    value: t.lazy(() => R().nullish())
  });
}
function nn() {
  return t.object({
    value: t.number().nullish()
  });
}
function wi() {
  return t.object({
    loggedIn: t.boolean(),
    userId: t.string().trim().min(1)
  });
}
function Hi() {
  return t.object({
    organizationId: t.string().trim().min(1),
    role: m.nullish(),
    userId: t.string().trim().min(1)
  });
}
function Ti() {
  return t.object({
    userId: t.string().trim().min(1),
    userRole: m
  });
}
function Ui() {
  return t.object({
    commitId: t.string().trim(),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    id: t.string().trim().min(1)
  });
}
function en() {
  return t.object({
    accountId: t.string().trim().min(1),
    password: t.string().trim().min(1),
    username: t.string().trim().min(1)
  });
}
function rn() {
  return t.object({
    databaseName: t.string().trim().min(1),
    schemaName: t.string().trim().min(1),
    stageName: t.string().trim().min(1),
    tableName: t.string().trim().min(1),
    warehouseName: t.string().trim().min(1)
  });
}
function Fi() {
  return t.object({
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim()
  });
}
function S() {
  return t.object({
    equalTo: t.string().trim().nullish(),
    notEqualTo: t.string().trim().nullish()
  });
}
function ki() {
  return t.object({
    dataRoomRequestId: t.string().trim().min(1),
    enclaveCommitId: t.string().trim(),
    enclaveConfigurationPin: t.string().trim(),
    signers: t.array(t.string().email().trim())
  });
}
function xi() {
  return t.object({
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    id: t.string().trim().min(1),
    validate: t.boolean()
  });
}
function zi() {
  return t.object({
    id: t.string().trim().min(1),
    testDatasets: t.array(e()).nullish()
  });
}
function e() {
  return t.object({
    encryptionKey: t.string().trim(),
    leafNodeId: t.string().trim().min(1),
    manifestHash: t.string().trim()
  });
}
function qi() {
  return t.object({
    computeNodeId: t.string().trim().min(1),
    id: t.string().trim().min(1),
    testDatasets: t.array(e()).nullish()
  });
}
function R() {
  return t.object({
    uniqueColumnIds: t.array(t.array(t.string().trim().min(1)))
  });
}
function Li() {
  return t.object({
    dataNodeId: t.string().trim().nullish(),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim()
  });
}
function Mi() {
  return t.object({
    advertiserDomains: t.array(t.string().trim().min(1)).nullish(),
    allowExclusionTargeting: t.boolean().nullish(),
    allowInsights: t.boolean().nullish(),
    allowLookalike: t.boolean().nullish(),
    allowMeasurements: t.boolean().nullish(),
    allowRetargeting: t.boolean().nullish(),
    allowRuleBasedAudiences: t.boolean().nullish(),
    id: t.string().trim().min(1),
    matchAnyDomain: t.boolean().nullish(),
    matchingIdFormat: a.nullish(),
    matchingIdHashingAlgorithm: d().nullish(),
    name: t.string().trim().nullish(),
    publisherParticipants: t.array(t.string().trim().min(1)).nullish()
  });
}
function Ji() {
  return t.object({
    collaborationRequestUsers: t.array(t.string().trim().min(1)).nullish(),
    description: i().nullish(),
    id: t.string().trim().min(1),
    logo: i().nullish(),
    marketIds: t.array(t.string().trim().min(1)).nullish(),
    name: i().nullish()
  });
}
function Oi() {
  return t.object({
    advertiserDomains: t.array(t.string().trim().min(1)).nullish(),
    allowExclusionTargeting: t.boolean().nullish(),
    allowInsights: t.boolean().nullish(),
    allowLookalike: t.boolean().nullish(),
    allowRetargeting: t.boolean().nullish(),
    allowRulesBasedAudiences: t.boolean().nullish(),
    id: t.string().trim().min(1),
    matchAnyDomain: t.boolean().nullish(),
    matchingIdFormat: a.nullish(),
    matchingIdHashingAlgorithm: d().nullish(),
    name: t.string().trim().nullish(),
    participants: t.array(t.string().trim().min(1)).nullish()
  });
}
function Bi() {
  return t.object({
    description: t.string().trim().nullish(),
    enableDevelopment: t.boolean().nullish(),
    enableInteractivity: t.boolean().nullish(),
    id: t.string().trim().min(1),
    requirePassword: t.boolean().nullish(),
    showOrganizationLogo: t.boolean().nullish(),
    title: t.string().trim().nullish()
  });
}
function Ki() {
  return t.object({
    id: t.string().trim().min(1),
    isArchived: t.boolean().nullish(),
    isFavorite: t.boolean().nullish()
  });
}
function Wi() {
  return t.object({
    config: t.string().trim().nullish(),
    dependencies: t.array(t.string().trim().min(1)).nullish(),
    id: t.string().trim().min(1),
    name: t.string().trim().nullish(),
    output: t.string().trim().nullish()
  });
}
function Vi() {
  return t.object({
    id: t.string().trim().min(1),
    participantEmail: t.string().trim().min(1)
  });
}
function Gi() {
  return t.object({
    id: t.string().trim().min(1),
    name: t.string().trim().nullish()
  });
}
function Qi() {
  return t.object({
    id: t.string().trim().min(1),
    name: t.string().trim().nullish(),
    quotaBytes: nn().nullish()
  });
}
function Xi() {
  return t.object({
    id: t.string().trim().min(1),
    isRequired: t.boolean().nullish(),
    name: t.string().trim().nullish()
  });
}
function Yi() {
  return t.object({
    endpoint: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    name: t.string().trim().nullish(),
    region: t.string().trim().nullish()
  });
}
function Zi() {
  return t.object({
    content: t.string().trim().nullish(),
    id: t.string().trim().min(1),
    isMainScript: t.boolean().nullish(),
    name: t.string().trim().nullish()
  });
}
function _i() {
  return t.object({
    id: t.string().trim().min(1),
    name: t.string().trim().nullish(),
    output: t.string().trim().nullish(),
    scriptingLanguage: I.nullish()
  });
}
function $i() {
  return t.object({
    id: t.string().trim().min(1),
    name: t.string().trim().nullish(),
    privacyFilterIsEnabled: t.boolean().nullish(),
    privacyFilterMinimumRow: t.number().nullish(),
    statement: t.string().trim().nullish()
  });
}
function te() {
  return t.object({
    id: t.string().trim().min(1),
    name: t.string().trim().nullish(),
    privacyFilterIsEnabled: t.boolean().nullish(),
    privacyFilterMinimumRow: t.number().nullish(),
    statement: t.string().trim().nullish()
  });
}
function ne() {
  return t.object({
    accuracy: t.number().nullish(),
    dependencyUpdatedAt: t.string().datetime().nullish(),
    id: t.string().trim().min(1),
    includeReportWithStats: t.boolean().nullish(),
    name: t.string().trim().nullish()
  });
}
function ie() {
  return t.object({
    dataType: s.nullish(),
    formatType: $t().nullish(),
    hashWith: d().nullish(),
    id: t.string().trim().min(1),
    isNullable: t.boolean().nullish(),
    name: t.string().trim().nullish()
  });
}
function ee() {
  return t.object({
    allowEmpty: t.boolean().nullish(),
    columnsOrder: t.array(t.string().trim().min(1)).nullish(),
    id: t.string().trim().min(1),
    isRequired: t.boolean().nullish(),
    maxRows: b().nullish(),
    minRows: b().nullish(),
    name: t.string().trim().nullish(),
    uniqueness: t.lazy(() => tn().nullish())
  });
}
function re() {
  return t.object({
    adformExportState: n.nullish(),
    allowExcludingSeedAudience: t.boolean().nullish(),
    azureExportState: n.nullish(),
    azureImportState: n.nullish(),
    canViewDataPartners: t.boolean().nullish(),
    canViewMeasurements: t.boolean().nullish(),
    computeImportState: n.nullish(),
    databricksImportState: n.nullish(),
    enableAudienceBuilder: t.boolean().nullish(),
    enableDmp: t.boolean().nullish(),
    enableExtendedLookalikeQualityStatistics: t.boolean().nullish(),
    googleAdManagerExportState: n.nullish(),
    googleAdsExportState: n.nullish(),
    googleCloudStorageExportState: n.nullish(),
    googleCloudStorageImportState: n.nullish(),
    googleDv360ExportState: n.nullish(),
    hasAdvertiserFeatures: t.boolean().nullish(),
    hasAnalyticsFeatures: t.boolean().nullish(),
    hasDataPartnerFeatures: t.boolean().nullish(),
    hasDatalabFeatures: t.boolean().nullish(),
    hasPublisherFeatures: t.boolean().nullish(),
    localImportState: n.nullish(),
    metaExportState: n.nullish(),
    microsoftDspExportState: n.nullish(),
    permutiveExportState: n.nullish(),
    permutiveImportState: n.nullish(),
    s3ExportState: n.nullish(),
    s3ImportState: n.nullish(),
    salesforceImportState: n.nullish(),
    skipMdcrAudiencesResettingOnDataLabChange: t.boolean().nullish(),
    snapchatExportState: n.nullish(),
    snowflakeImportState: n.nullish(),
    splickyExportState: n.nullish(),
    sportradarExportState: n.nullish(),
    tiktokExportState: n.nullish(),
    tradedeskExportState: n.nullish(),
    useLegacyDataLabs: t.boolean().nullish()
  });
}
function ae() {
  return t.object({
    allowedDomains: t.array(t.string().trim().min(1)).nullish(),
    authPolicy: t.string().trim().nullish(),
    description: i().nullish(),
    id: t.string().trim().min(1),
    logo: i().nullish(),
    mediaScope: i().nullish(),
    microsoftDspMember: t.string().trim().nullish(),
    name: t.string().trim().nullish(),
    workerTypes: t.array(t.string().trim().min(1)).nullish()
  });
}
function oe() {
  return t.object({
    containerWorkerMaxRuntimeSeconds: t.number().nullish(),
    organizationId: t.string().trim().min(1)
  });
}
function se() {
  return t.object({
    id: t.string().trim().min(1),
    newEnclaveCommitId: t.string().trim().nullish(),
    newEnclaveConfigurationPin: t.string().trim().min(1)
  });
}
function me() {
  return t.object({
    id: t.string().trim().min(1),
    isArchived: t.boolean().nullish(),
    isFavorite: t.boolean().nullish()
  });
}
function ue() {
  return t.object({
    collaborationRequestUsers: t.array(t.string().trim().min(1)).nullish(),
    description: i().nullish(),
    id: t.string().trim().min(1),
    logo: i().nullish(),
    marketIds: t.array(t.string().trim().min(1)).nullish(),
    publisherName: i().nullish()
  });
}
function le() {
  return t.object({
    id: t.string().trim().min(1),
    maskType: D.nullish(),
    shouldMaskColumn: t.boolean().nullish()
  });
}
function ce() {
  return t.object({
    hasLoggedInBefore: t.boolean().nullish(),
    isDemoUser: t.boolean().nullish(),
    logo: i().nullish(),
    needsMigration: t.boolean().nullish(),
    userId: t.string().trim().min(1)
  });
}
function he() {
  return t.object({
    content: t.string().trim(),
    csvOptions: t.lazy(() => yt().nullish()),
    dataRoomId: t.string().trim().min(1),
    description: t.string().trim().nullish(),
    encryptionKey: t.string().trim(),
    name: t.string().trim().min(1),
    progressTotal: t.number().nullish(),
    statistics: t.string().trim().nullish()
  });
}
function ge() {
  return t.object({
    csrPem: t.string().trim().min(1),
    email: t.string().trim().min(1)
  });
}
function de() {
  return t.object({
    autoFetching: t.boolean().nullish(),
    dcrHash: t.string().trim(),
    driverAttestationHash: t.string().trim(),
    id: t.string().trim().min(1),
    testDatasets: t.array(e()).nullish()
  });
}
export {
  bn as ApproveSubmittedDataRoomRequestLocalInputSchema,
  c as AwsCredentialsSchema,
  j as AzureCredentialsSchema,
  u as BoolCompareSchema,
  Sn as CollaboratingOrganizationFilterSchema,
  s as ColumnDataTypeSchema,
  mn as ComputeJobAutoFetchingSchema,
  $ as ComputeJobPurposeSchema,
  un as ComputeJobStatusSchema,
  fn as CreateActivationConfigurationInputSchema,
  In as CreateApiTokenInputSchema,
  Dn as CreateComputeJobInputSchema,
  jn as CreateDataConnectorJobInputSchema,
  st as CreateDataConnectorJobPayloadSchema,
  yn as CreateDataLabFromExistingInputSchema,
  Cn as CreateDataLabInputSchema,
  vn as CreateDataPartnerDisplayConfigurationInputSchema,
  Rn as CreateDataPartnerUsageConfigurationInputSchema,
  Nn as CreateDataRoomPlaygroundInputSchema,
  En as CreateDataRoomRequestInputSchema,
  An as CreateDataRoomRequestSignatureInputSchema,
  Pn as CreateDatasetForUploadInputSchema,
  wn as CreateDatasetScopeInputSchema,
  Hn as CreateDcrDataScopeInputSchema,
  Tn as CreateDemoUserInputSchema,
  mt as CreateDraftAnalystPermissionForParticipantInputSchema,
  Un as CreateDraftAnalystPermissionInputSchema,
  y as CreateDraftComputationNodeInputSchema,
  ut as CreateDraftDataOwnerPermissionForParticipantInputSchema,
  Fn as CreateDraftDataOwnerPermissionInputSchema,
  kn as CreateDraftDataRoomInputSchema,
  xn as CreateDraftDataRoomUserSettingsInputSchema,
  zn as CreateDraftEditorInputSchema,
  lt as CreateDraftMatchNodeInputSchema,
  qn as CreateDraftParticipantInputSchema,
  ct as CreateDraftPermissionForParticipantInputSchema,
  ht as CreateDraftPostNodeInputSchema,
  gt as CreateDraftPreviewNodeInputSchema,
  Ln as CreateDraftRawLeafNodeInputSchema,
  dt as CreateDraftS3SinkNodeInputSchema,
  Mn as CreateDraftScriptInputSchema,
  pt as CreateDraftScriptingNodeInputSchema,
  bt as CreateDraftSqlNodeInputSchema,
  St as CreateDraftSqliteNodeInputSchema,
  ft as CreateDraftSyntheticNodeInputSchema,
  Jn as CreateDraftTableLeafNodeColumnInputSchema,
  On as CreateDraftTableLeafNodeInputSchema,
  Bn as CreateErrorReportInputSchema,
  It as CreateExportDatasetPayloadSchema,
  Dt as CreateExportDcrJobResultPayloadSchema,
  Kn as CreateExternalUserInputSchema,
  jt as CreateImportDatasetPayloadSchema,
  Wn as CreateInternalUserInputSchema,
  Vn as CreateMediaComputeJobInputSchema,
  Gn as CreateOrganizationInputSchema,
  Qn as CreatePublishedDataRoomUserSettingsInputSchema,
  Xn as CreatePublisherDisplayConfigurationInputSchema,
  Yn as CreateSessionInputSchema,
  Zn as CreateSyntheticNodeColumnForSyntheticNodeInputSchema,
  yt as CsvOptionsInputSchema,
  _n as DataConnectorJobFilterSchema,
  ln as DataConnectorJobTypeSchema,
  tt as DataImportExportStatusSchema,
  $n as DataRoomFilterSchema,
  cn as DataRoomKindSchema,
  ti as DataRoomSortBySchema,
  nt as DataSourceTypeSchema,
  f as DataTargetTypeSchema,
  it as DatasetUsageSchema,
  h as DateRangeSchema,
  ni as DeleteDatasetInputSchema,
  ii as DeleteMediaComputeJobInputSchema,
  et as DraftEditorRoleSchema,
  Ct as ErrorContextEntryInputSchema,
  vt as ErrorReportPayloadInputSchema,
  Rt as ExportDatasetConfigAdformDspSchema,
  Nt as ExportDatasetConfigAzureSchema,
  Et as ExportDatasetConfigDv360Schema,
  C as ExportDatasetConfigGcsSchema,
  At as ExportDatasetConfigGoogleAdManagerSchema,
  Pt as ExportDatasetConfigMetaSchema,
  wt as ExportDatasetConfigMicrosoftDspSchema,
  Ht as ExportDatasetConfigPermutiveSchema,
  g as ExportDatasetConfigS3Schema,
  Tt as ExportDatasetConfigSplickySchema,
  ei as ExportDatasetInputSchema,
  n as FeatureVisibilityStateSchema,
  ri as ImportDataScienceDataRoomInputSchema,
  Ut as ImportDatasetConfigAzureSchema,
  Ft as ImportDatasetConfigComputeSchema,
  kt as ImportDatasetConfigGcsSchema,
  xt as ImportDatasetConfigPermutiveSchema,
  zt as ImportDatasetConfigS3Schema,
  qt as ImportDatasetConfigSalesforceSchema,
  Lt as ImportDatasetConfigSnowflakeSchema,
  ai as ImportDatasetInputSchema,
  Mt as ImportDatasetPermutiveAwsConfigurationSchema,
  Jt as ImportDatasetPermutiveConfigurationSchema,
  Ot as ImportDatasetPermutiveCredentialsSchema,
  Bt as ImportDatasetPermutiveDatasetsSchema,
  Kt as ImportDatasetPermutiveGcsConfigurationSchema,
  Wt as ImportDraftScriptInputSchema,
  Vt as ImportDraftTableLeafNodeColumnInputSchema,
  oi as InviteParticipantsInputSchema,
  a as MatchingColumnFormatSchema,
  si as MediaComputeJobFilterInputSchema,
  mi as MergeSubmittedDataRoomRequestInputSchema,
  v as NodeIdSchema,
  ui as OrganizationDataRoomFilterSchema,
  rt as OrganizationStateSchema,
  Gt as ParameterSchema,
  Qt as PermutiveCredentialsSchema,
  Xt as PermutiveGcsCredentialsSchema,
  at as PermutiveServiceProviderSchema,
  li as PollComputeJobInputSchema,
  ci as PreviewComputationInputSchema,
  hi as ProvisionDataLabInputSchema,
  gi as PublishDatasetInputSchema,
  di as PublishDraftDataRoomInputSchema,
  pi as PublishDraftDataRoomLocalInputSchema,
  hn as PublishedDataRoomSourceSchema,
  bi as RebaseSubmittedDataRoomRequestInputSchema,
  Si as RebaseSubmittedDataRoomRequestLocalInputSchema,
  fi as RetrieveComputationFormatInDraftDataRoomInputSchema,
  Ii as RetrieveComputationFormatInPublishedDataRoomInputSchema,
  Di as RetrieveComputeJobResultFileInputSchema,
  ji as RetrieveComputeJobResultInputSchema,
  yi as RunComputationInputSchema,
  Ci as RunDevComputationInputSchema,
  vi as RunSubmittedDataRoomRequestInputSchema,
  Yt as S3SourceSchema,
  Zt as S3TargetSchema,
  _t as SalesforceCredentialsSchema,
  ot as SalesforceProductTypeSchema,
  gn as ScopeTypeSchema,
  I as ScriptingLanguageSchema,
  Ri as SetDataLabDatasetInputSchema,
  Ni as SetDataLabJobIdsInputSchema,
  Ei as SetDataLabStatisticsInputSchema,
  Ai as SetJobIdForDataConnectorJobInputSchema,
  b as SetLongSchema,
  i as SetStringSchema,
  $t as SetTableColumnFormatTypeSchema,
  d as SetTableColumnHashingAlgorithmSchema,
  Pi as SetTestModePublicationInputSchema,
  tn as SetUniqueValidationSettingsInputSchema,
  nn as SetUnsignedLongSchema,
  wi as SetUserLoggedInBeforeInputSchema,
  Hi as SetUserOrganizationInputSchema,
  Ti as SetUserRoleInputSchema,
  Ui as SignSubmittedDataRoomRequestLocalInputSchema,
  en as SnowflakeCredentialsSchema,
  rn as SnowflakeSourceSchema,
  p as SortOrderSchema,
  Fi as StopDataRoomInputSchema,
  S as StringCompareSchema,
  ki as SubmitDataRoomRequestInputSchema,
  xi as SubmitDataRoomRequestLocalInputSchema,
  dn as SubmittedDataRoomRequestProcessingStatusSchema,
  D as SyntheticMaskTypeSchema,
  l as TableColumnFormatTypeSchema,
  r as TableColumnHashingAlgorithmSchema,
  zi as TestAllComputationsInputSchema,
  e as TestDatasetSchema,
  qi as TestDraftComputationInputSchema,
  R as UniquenessValidationSettingsInputSchema,
  Li as UnpublishDatasetInputSchema,
  Mi as UpdateActivationConfigurationInputSchema,
  Ji as UpdateDataPartnerDisplayConfigurationInputSchema,
  Oi as UpdateDataPartnerUsageConfigurationInputSchema,
  Bi as UpdateDraftDataRoomInputSchema,
  Ki as UpdateDraftDataRoomUserSettingsInputSchema,
  Wi as UpdateDraftMatchNodeInputSchema,
  Vi as UpdateDraftParticipantInputSchema,
  Gi as UpdateDraftPostNodeInputSchema,
  Qi as UpdateDraftPreviewNodeInputSchema,
  Xi as UpdateDraftRawLeafNodeInputSchema,
  Yi as UpdateDraftS3SinkNodeInputSchema,
  Zi as UpdateDraftScriptInputSchema,
  _i as UpdateDraftScriptingNodeInputSchema,
  $i as UpdateDraftSqlNodeInputSchema,
  te as UpdateDraftSqliteNodeInputSchema,
  ne as UpdateDraftSyntheticNodeInputSchema,
  ie as UpdateDraftTableLeafNodeColumnInputSchema,
  ee as UpdateDraftTableLeafNodeInputSchema,
  re as UpdateOrganizationFlagsInputSchema,
  ae as UpdateOrganizationInputSchema,
  oe as UpdateOrganizationQuotasInputSchema,
  se as UpdatePlaygroundInputSchema,
  me as UpdatePublishedDataRoomUserSettingsInputSchema,
  ue as UpdatePublisherDisplayConfigurationInputSchema,
  le as UpdateSyntheticNodeColumnInputSchema,
  ce as UpdateUserInputSchema,
  he as UploadDatasetInputSchema,
  ge as UserCsrInputSchema,
  m as UserRoleSchema,
  de as ValidateDataRoomRequestInputSchema,
  pn as WorkerTypeShortNameSchema,
  sn as definedNonNullAnySchema,
  _ as isDefinedNonNullAny
};
//# sourceMappingURL=validation.js.map
